export const COMPOSE_STORAGE_KEYS = {
  SELECTED_TYPE: 'tm::compose::toggle-value',
} as const
